import { API } from '@Providers';

export default async function () {
  const endpoint = '/api/shelter/cart/remove-discount/';

  return API({ endpoint, method: 'post' });
}
